import { FilterSort } from 'addiction-components';

export const DOCUMENT_SORT = {
  NAME_ASC: { label: 'DOCUMENTS.SORT.NAME_ASC', value: 'name#asc' },
  NAME_DESC: { label: 'DOCUMENTS.SORT.NAME_DESC', value: 'name#desc' },
  SIZE_ASC: { label: 'DOCUMENTS.SORT.SIZE_ASC', value: 'bytes#asc' },
  SIZE_DESC: { label: 'DOCUMENTS.SORT.SIZE_DESC', value: 'bytes#desc' },
  UPDATED_ASC: { label: 'DOCUMENTS.SORT.UPDATED_ASC', value: 'updateDate#asc' },
  UPDATED_DESC: { label: 'DOCUMENTS.SORT.UPDATED_DESC', value: 'updateDate#desc' },
  CREATED_ASC: { label: 'DOCUMENTS.SORT.CREATED_ASC', value: 'createDate#asc' },
  CREATED_DESC: { label: 'DOCUMENTS.SORT.CREATED_DESC', value: 'createDate#desc' },
};

export const DOCUMENT_SORT_OPTIONS: FilterSort[] = Object.values(DOCUMENT_SORT);
export const DEFAULT_DOCUMENT_SORT: FilterSort = DOCUMENT_SORT.UPDATED_DESC;
